module.exports = __webpack_public_path__ + "img/footer_profile--active.032012f6.svg";